// istanbul ignore file
import { useQuery } from '@tanstack/react-query';
import { prismService } from '../../prism/data-service/prism-service';

export const useDeviceViewsQuery = () =>
  useQuery({
    queryKey: ['prism', 'deviceViews'],
    queryFn: () => prismService.getDeviceViews(),
  });
